// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-activate {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-root);
  padding: 24px 16px;
}

.referral-activate-card {
  width: min(420px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: referralActivateIn 0.2s ease;
}

@keyframes referralActivateIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.referral-activate-badge {
  align-self: flex-start;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-accent-base);
  border: 1px solid var(--color-accent-base);
  padding: 3px 8px;
}

.referral-activate-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.referral-activate-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.referral-activate-subtitle strong {
  color: var(--color-text-primary);
}

.referral-activate-breakdown {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
}

.referral-activate-breakdown-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: var(--color-text-secondary);
}

.referral-activate-breakdown-row.referral-activate-bonus {
  color: var(--color-accent-base);
}

.referral-activate-breakdown-row.referral-activate-bonus .referral-activate-amount {
  color: var(--color-accent-base);
  font-weight: 700;
}

.referral-activate-breakdown-divider {
  height: 1px;
  background: var(--color-border-input);
}

.referral-activate-breakdown-row.referral-activate-total {
  color: var(--color-text-primary);
  font-weight: 600;
}

.referral-activate-amount {
  font-weight: 600;
  color: var(--color-text-primary);
}

.referral-activate-tiers {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.referral-activate-tier {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 14px 8px;
  background: var(--color-bg-input);
  border: 2px solid var(--color-border-input);
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.1s;
}

.referral-activate-tier:hover {
  border-color: var(--color-text-secondary);
}

.referral-activate-tier.selected {
  border-color: var(--color-accent-base);
  background: var(--color-bg-canvas-surface);
}

.referral-activate-tier-amount {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.referral-activate-tier-tag {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-accent-base);
}

.referral-activate-primary {
  width: 100%;
  padding: 12px 14px;
  border: none;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  font-family: inherit;
}

.referral-activate-primary:hover:not(:disabled) {
  filter: brightness(0.96);
}

.referral-activate-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.referral-activate-skip {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  font-family: inherit;
}

.referral-activate-skip:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.referral-activate-error {
  font-size: 13px;
  color: var(--color-danger, #e55);
  text-align: center;
  margin: 0;
}

.referral-activate-success-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text-on-accent);
  background: var(--color-accent-base);
}

@media (max-width: 640px) {
  .referral-activate-card {
    padding: 24px 18px;
  }

  .referral-activate-title {
    font-size: 19px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ReferralActivatePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".referral-activate {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg-root);\n  padding: 24px 16px;\n}\n\n.referral-activate-card {\n  width: min(420px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 32px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  animation: referralActivateIn 0.2s ease;\n}\n\n@keyframes referralActivateIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.referral-activate-badge {\n  align-self: flex-start;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--color-accent-base);\n  border: 1px solid var(--color-accent-base);\n  padding: 3px 8px;\n}\n\n.referral-activate-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.referral-activate-subtitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n.referral-activate-subtitle strong {\n  color: var(--color-text-primary);\n}\n\n.referral-activate-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n}\n\n.referral-activate-breakdown-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.referral-activate-breakdown-row.referral-activate-bonus {\n  color: var(--color-accent-base);\n}\n\n.referral-activate-breakdown-row.referral-activate-bonus .referral-activate-amount {\n  color: var(--color-accent-base);\n  font-weight: 700;\n}\n\n.referral-activate-breakdown-divider {\n  height: 1px;\n  background: var(--color-border-input);\n}\n\n.referral-activate-breakdown-row.referral-activate-total {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.referral-activate-amount {\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.referral-activate-tiers {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.referral-activate-tier {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 14px 8px;\n  background: var(--color-bg-input);\n  border: 2px solid var(--color-border-input);\n  cursor: pointer;\n  font-family: inherit;\n  transition: border-color 0.1s;\n}\n\n.referral-activate-tier:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.referral-activate-tier.selected {\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-canvas-surface);\n}\n\n.referral-activate-tier-amount {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.referral-activate-tier-tag {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-accent-base);\n}\n\n.referral-activate-primary {\n  width: 100%;\n  padding: 12px 14px;\n  border: none;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.referral-activate-primary:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.referral-activate-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.referral-activate-skip {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.referral-activate-skip:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.referral-activate-error {\n  font-size: 13px;\n  color: var(--color-danger, #e55);\n  text-align: center;\n  margin: 0;\n}\n\n.referral-activate-success-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-text-on-accent);\n  background: var(--color-accent-base);\n}\n\n@media (max-width: 640px) {\n  .referral-activate-card {\n    padding: 24px 18px;\n  }\n\n  .referral-activate-title {\n    font-size: 19px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
